export default __webpack_public_path__ + "static/NBInternationalPro-Regular-12736592b679ce84aa4bae51212ec587.woff2";